import React from "react";
import { Link } from "react-router-dom";
import MenuDropdown from "./MenuDropdown";
import MyProfile from "./MyProfile";
// import Notifications from "./Notifications";
import useUniComponent from "../../hooks/useUniComponent";
import { useAuthContext } from "../../context/AuthContext";
import HelpHyperLink from "../HelpHyperLink";
import LoadingModal from "../LoadingModal";
import { useUIContext } from "../../context/UIContext";
import { useTranslation } from "react-i18next";
import LanguageSelector from "../LanguageSelector";

/* 
여기 들어가야 할 내용
1. 학교별 로고
2. 교직원 권한별 메뉴 드랍다운
3. 내정보 프로필
4. authentification context
5. 모바일일 때 sidebar로 바뀌기
*/

export default function MainNavbar() {
  const { user, selectedChild, handleSelectedChild } = useAuthContext();
  const { t } = useTranslation();
  const {
    commonMenus: allMenus,
    isLoading,
    error,
    userRole,
  } = useUniComponent();

  const { isLoadingModal, handleToastCenterTop } = useUIContext();

  const messagePopup = () => {
    handleToastCenterTop(t("common.uniComponents.contactAdmin"));
    setTimeout(() => {
      window.open(
        "https://docs.google.com/forms/d/e/1FAIpQLSev67sNIFU22Ze3ADyb27mTBnKql_pOri8SyObqlnIH4lJw0A/viewform?usp=sf_link",
        "_blank",
      );
    }, 2000);
  };

  return (
    <header
      style={{
        height: "65px",
        width: "98vw",
        position: "relative", // sticky 원하면 sticky + top: 0
        zIndex: 1030,
      }}
      className="container-fluid border-bottom border-2 d-none d-sm-flex ps-4"
    >
      {isLoadingModal && <LoadingModal />}
      <div className="row align-items-center w-100">
        <div className="col-1">
          <Link
            to={
              user?.schoolid ? `/${user.schoolid}/${userRole}/dashboard` : "/"
            }
            className="text-center align-self-center"
          >
            <img alt="에듀씨드" src="/images/eduseedLogo.png" height="50px" />
          </Link>
        </div>
        <div className="col-9 d-flex flex-wrap justify-content-around">
          {isLoading && <p>Loading...</p>}
          {error && <p>{error.message || error}</p>}
          {allMenus &&
            allMenus
              .filter(
                (menu) =>
                  menu.components === "Appbar" &&
                  menu.parentcategory === "parent" &&
                  menu.display === true,
              )
              .sort(function (a, b) {
                return a.categoryorder - b.categoryorder;
              })
              .map((menu, key) => (
                <MenuDropdown
                  key={menu.id}
                  parentMenu={menu}
                  subMenus={allMenus}
                  user={user}
                />
              ))}
          <div>
            <button
              className="btn btn-sm"
              type="button"
              key="feedback"
              onClick={messagePopup}
            >
              {t("common.uniComponents.feedback")}
            </button>
          </div>
        </div>
        <div className="col-2 d-flex justify-content-evenly">
          {user?.role === "parent" && (
            <div className="text-center">
              <label
                htmlFor="childSelect"
                style={{ minWidth: "48px", fontSize: "12px" }}
              >
                {t("common.uniComponents.selectChild") || "자녀 선택"}
              </label>
              <select
                id="childSelect"
                value={selectedChild}
                onChange={(e) => handleSelectedChild(e.target.value)}
                className="form-control p-1 mt-0"
                style={{ fontSize: "13px" }}
              >
                {user?.guardian?.map((child) => (
                  <option key={child.username} value={child.username}>
                    {child.fullname || child.username || ""}
                  </option>
                ))}
                <option value="linkRequest">
                  {t("common.uniComponents.linkChild")}
                </option>
              </select>
            </div>
          )}
          <LanguageSelector />
          <MyProfile subMenus={allMenus} user={user} />
          {(user?.role === "teacher" || user?.role === "admin") && (
            <HelpHyperLink link={"https://youtu.be/hycTioZ4ucY"} />
          )}

          {/* <Notifications subMenus={allMenus} user={user} /> */}
        </div>
      </div>
    </header>
  );
}
